<!-- SwipFx Orders Page - Filterable Order Book (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">

    <app-header [page]="'Accounts'"></app-header>
    <main class="container py-4">

  <div class="card shadow-sm border-0 mx-auto" style="max-width: 680px;">
    <div class="card-body p-4">
      <h3 class="fw-bold mb-2">Resubmit Application</h3>
      <p class="text-muted">
        Use this when an application was rejected and you want to reopen it after making corrections.
      </p>

      <div *ngIf="error" class="alert alert-danger">
        {{ error }}
      </div>

      <div *ngIf="success" class="alert alert-success">
        {{ success }}
      </div>

      <div class="form-check form-switch mb-4">
        <input
          class="form-check-input"
          type="checkbox"
          id="clearReviewNotes"
          [(ngModel)]="clearPreviousReviewNotes">

        <label class="form-check-label" for="clearReviewNotes">
          Clear previous review notes before resubmitting
        </label>
      </div>

      <div class="d-flex gap-2">
        <button class="btn btn-outline-secondary btn-sm" routerLink="/compliance">
          Cancel
        </button>

        <button class="btn btn-primary btn-sm"
                (click)="submit()"
                [disabled]="loading">
          <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
          Resubmit
        </button>
      </div>
    </div>
  </div>
<app-footer></app-footer>
</main>
</div>